import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useHistory }  from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import ModalPopup from 'components/modal';
import CommonUtil from 'utils/CommonUtil';
import useToggleState from 'components/hooks/useToggleState';
import UIUtils from "utils/UIUtils";
import paramStore from "common/page/store/ParamStore";
function ContentsContainer() {
  	const location = useLocation();
  	const receivedData = paramStore.getParam("adm6713");
	const history = useHistory();
	
	const [BIZ_NO_DISP,	SetBIZ_NO_DISP] = useState('');
	const [BIZ_NM,	SetBIZ_NM] = useState('');
	const [BANK_NM,	SetBANK_NM] = useState('');
	const [FIRM_NM,	SetFIRM_NM] = useState('')
	const [FIRM_CD,	SetFIRM_CD] = useState('')
	const [VAN_GB_NM,	SetVAN_GB_NM] = useState('')
	const [SND_ID,	SetSND_ID] = useState('');
	const [RCV_ID,	SetRCV_ID] = useState('');
	const [BIZ_NO,	SetBIZ_NO] = useState('');
	const [BANK_CD,	SetBANK_CD] = useState('');
	const [VAN_GB,	SetVAN_GB] = useState('');
	const [ACCT_NO,	SetACCT_NO] = useState('');
	const [ACCT_NM,	 SetACCT_NM] = useState('');
	const [ACCT_IDX, SetACCT_IDX] = useState('');
	
	const [ACCT_NO_R, SetACCT_NO_R] = useState('');
	const [ACCT_NM_R, SetACCT_NM_R] = useState('');
	
	const [modal6714IsOpen, setmodal6714IsOpen] = useState(false);
	const [modal6715IsOpen, setmodal6715IsOpen] = useState(false);
	
	const [DEF_ACCT_YN, setDEF_ACCT_YN] = useState('N');

	const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDEF_ACCT_YN(event.target.value);
	};
  	
    let data = {};
    let SheetData = {};

	var ib = {
		'init':{
	        "Cfg": {
	            "SearchMode": 0,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",		            
	            "Height": "auto",
	        },
	
	        "Cols": [
	            {"Header": "NO",			"Type": "Int", 	"Name": "SEQ",					"RelWidth": 1,		"Align": "Center"},
	            {"Header": "펌뱅킹기관코드",		"Type": "Text",	"Name": "FIRM_CD",				"RelWidth": 1.5,	"Align": "Center"},
	            {"Header": "은행",			"Type": "Text",	"Name": "BANK_NM",				"RelWidth": 1.5,	"Align": "Center"},
	            {"Header": "계좌번호",			"Type": "Text",	"Name": "ACCT_NO_DES",			"RelWidth": 2,		"Align": "left"},
	            {"Header": "계좌별칭",			"Type": "Text",	"Name": "ACCT_NM",				"RelWidth": 4,		"Align": "left"},
	            {"Header": "대표계좌설정",		"Type": "Text",	"Name": "DEF_ACCT_YN_DISP",		"RelWidth": 2,		"Align": "Center"},
	            {"Header": "ACCT_NO",		"Type": "Text",	"Name": "ACCT_NO",				"RelWidth": 3, 		Visible : 0},
	            {"Header": "DEF_ACCT_YN",	"Type": "Text",	"Name": "DEF_ACCT_YN",			"RelWidth": 1.5, 	Visible : 0},
	            {"Header": "BANK_CD",		"Type": "Text",	"Name": "BANK_CD",				"RelWidth": 1.5, 	Visible : 0},
	            {"Header": "ACCT_IDX",		"Type": "Text",	"Name": "ACCT_IDX",				"RelWidth": 1.5, 	Visible : 0},
	            
	        ],
		},
	        
    	'event':{
			onRenderFirstFinish:function (evtParam) {
				initSheet();
		      
			},
		
	    	onDblClick:function(evtParam:object){
				//@ts-ignore
				var row = Main_sheet.getFocusedRow();
				var vACCT_NO = row["ACCT_NO"];
				var vACCT_NM = row["ACCT_NM"];
				var vDEF_ACCT_YN = row["DEF_ACCT_YN"];
				var vACCT_IDX = row["ACCT_IDX"];
			
				SetACCT_NO(vACCT_NO);
				SetACCT_NM(vACCT_NM);
				setDEF_ACCT_YN(vDEF_ACCT_YN);
				SetACCT_IDX(vACCT_IDX);
				
				setmodal6715IsOpen(true);
				
	    	},		  			
		},		
		
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Main_sheet', // 생성할 시트의 id
				el: 'AcctList', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터
				
			});
			// global 변수 선언
			//@ts-ignore
		},

    }

    async function onClickList(event) {
    	event.preventDefault();		
	    let dataToSend = {};
	     paramStore.setParam("adm6710", dataToSend);
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: 'adm6710',
	      state: { data: dataToSend }
	    });

    }
        
    async function initSheet() {
		const response:any = await CommonUtil.execute({
            url:"adm_6713_r001",
            data: {
				"FIRM_CD": receivedData.vFIRM_CD,
				"BANK_CD": receivedData.vBANK_CD,
			}
        })
        .then((response: any) => {          
			data = response.REC;
			
			//@ts-ignore
	        Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        //@ts-ignore
	        Main_sheet.loadSearchData(data);
       	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	        
	    	
    }
    
	React.useEffect(() => {
        SetBIZ_NO_DISP(receivedData.vBIZ_NO_DISP);
        SetBIZ_NM(receivedData.vBIZ_NM);
        SetBANK_NM(receivedData.vBANK_NM);
        SetFIRM_NM(receivedData.vFIRM_NM);
        SetFIRM_CD(receivedData.vFIRM_CD);
        SetVAN_GB_NM(receivedData.vVAN_GB_NM);
        SetSND_ID(receivedData.vSND_ID);
        SetRCV_ID(receivedData.vRCV_ID);
        SetBIZ_NO(receivedData.vBIZ_NO);
        SetBANK_CD(receivedData.vBANK_CD);
        SetVAN_GB(receivedData.vVAN_GB);
        
        // @ts-ignore
   		ib.create();

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }

    },[])	

    async function onClickChange() {
		var vBIZ_NO_DISP = BIZ_NO_DISP;
		var vBIZ_NM = BIZ_NM;
		var vBANK_NM = BANK_NM;
		var vFIRM_NM = FIRM_NM;
		var vFIRM_CD = FIRM_CD;
		var vVAN_GB_NM = VAN_GB_NM;
		var vSND_ID = SND_ID;
		var vRCV_ID = RCV_ID;
		var vBIZ_NO = BIZ_NO;
		var vBANK_CD = BANK_CD;
		var vVAN_GB = VAN_GB;
		
	    let dataToSend = {vBIZ_NO_DISP, vBIZ_NM, vBANK_NM, vFIRM_NM, vFIRM_CD, vVAN_GB_NM, vSND_ID, vRCV_ID, vBIZ_NO, vBANK_CD, vVAN_GB};
	    paramStore.setParam("adm6712", dataToSend);

	    history.push({
	      pathname: 'adm6712',
	      state: { data: dataToSend }
	    });

    };    

    async function onClickSearch() {
		const response:any = await CommonUtil.execute({
            url:"adm_6713_r001",
            data: {
				"FIRM_CD": FIRM_CD,
				"BANK_CD": BANK_CD,
			}
        })
        .then((response: any) => {          
			data = response.REC;
		
			// @ts-ignore
	        Main_sheet.loadSearchData(data);  //data 로딩 처리 
       	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	          

    }; 
    
    async function onClickSave(event) {
    	event.preventDefault();		
    	
		if (ACCT_NO_R === '' || ACCT_NM_R === '') {
			UIUtils.alert('*항목은 필수입력입니다.').then();
			return;
		} 
		   	
        if(await UIUtils.confirm('저장하시겠습니까?')){		
	        const response:any = await CommonUtil.execute({
	            url:"adm_6713_c002",
	            data: {
					"BANK_CD" : BANK_CD,
					"ACCT_NO": ACCT_NO_R,
					"ACCT_NM": ACCT_NM_R,
					"OPR_DIV_CD" : "1",
					"FIRM_CD" : FIRM_CD,
					"VACCT_YN" : "Y",
					"DEF_ACCT_YN" : DEF_ACCT_YN,	
				}
	        })
			.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then();
	            // @ts-ignore
	            SetACCT_NO_R('');
	            SetACCT_NM_R('');
	            setDEF_ACCT_YN('N');
	            onClose6714();
	            onClickSearch();
			}).catch((error) => {
		    	CommonUtil.showAxiosError(error);
		    	return;
	       	});	  
	       	
		}
		
    };       
    
    async function onClickUpdate(event) {
    	event.preventDefault();
    	
		if (ACCT_NO === '' || ACCT_NM === '') {
			UIUtils.alert('*항목은 필수입력입니다.').then();
			return;
		}   
		
		if(await UIUtils.confirm('수정하시겠습니까?')){		
	        const response:any = await CommonUtil.execute({
	            url:"adm_6713_u003",
	            data: {
					"BANK_CD" : BANK_CD,			
					"ACCT_NO": ACCT_NO,
					"ACCT_NM": ACCT_NM,
					"DEF_ACCT_YN" : DEF_ACCT_YN,
					"ACCT_IDX" : ACCT_IDX,				
				}
	        })
			.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then();
	            onClose6715();
	            onClickSearch();
	            setDEF_ACCT_YN('N');
			}).catch((error) => {
		    	CommonUtil.showAxiosError(error);
		    	return;
	       	});	        	        
		}

    };  
         
	async function onClose6714() {
		setmodal6714IsOpen(false);
		
	}	        

	async function onClose6715() {
		setmodal6715IsOpen(false);
		
	}	        
	
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">시스템관리</Link></li>
					<li><Link to="#">펌뱅킹관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">펌뱅킹정보 상세</h1>
					<h2 className="tx tx-hd3">기본정보</h2>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">사업자번호</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={BIZ_NO_DISP} placeholder={'-없이 숫자만'} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">사업장</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w100p'} value={BIZ_NM} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">펌뱅킹 별칭</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w100p'} value={FIRM_NM} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">은행</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w100p'} value={BANK_NM} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">VAN구분</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w100p'} value={VAN_GB_NM} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">기관코드</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={FIRM_CD} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">송신 아이디</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={SND_ID} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">수신 아이디</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={RCV_ID} placeholder={''} attrs={{ readOnly: true }}/>
								</div>
							</div>
						</div> 
					</form>
					<h2 className="tx tx-hd3">모계좌정보</h2>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>
						</div>
						<div className="hz-root">
							<Button color="gray-o" size="md" onClick={() => setmodal6714IsOpen(true)}>모계좌 등록</Button>
						</div>
					</div>
					<div id='AcctList' className='ibsheet'></div>
					<div className="hz-root hz-right hz-gap5 mt10">
						<Button color="pri-o" size="sm" onClick={onClickChange}>수정</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>
				</main>
			</div>
			
			{/* modal - 6714 */}
			<ModalPopup
				open={modal6714IsOpen}
				title="모계좌관리 등록"
				size="sm"
				onClose={() => onClose6714()}
			>
				<div className="modal-con">
				<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">펌뱅킹기관코드</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={FIRM_CD} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">은행</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={BANK_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">계좌번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ACCT_NO_R} placeholder={'- 숫자만 입력'} type='number' valueChanged={(value) => SetACCT_NO_R(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">계좌별칭</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ACCT_NM_R} placeholder={''} valueChanged={(value) => SetACCT_NM_R(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">대표계좌</p>
								<div className="fo-value">
									<div className="hz-root hz-gap15 h36">
										<label htmlFor="rd-1-1" className="ip-rd-label">
											<input name="rd-1" id="rd-1-1" className="ip-rd" type="radio" value='Y' checked={DEF_ACCT_YN === 'Y'} onChange={handleOptionChange}/>
											<span className="check"></span>
											<span className="txt">예</span>
										</label>
										<label htmlFor="rd-1-2" className="ip-rd-label">
											<input name="rd-1" id="rd-1-2" className="ip-rd" type="radio" value='N' checked={DEF_ACCT_YN === 'N'} onChange={handleOptionChange}/>
											<span className="check"></span>
											<span className="txt">아니오</span>
										</label>
									</div>									
								</div>
							</div>

						</div>
					</form>
				</div>
				<div className="modal-bottom">
				<div className="hz-root hz-gap8">
						<Button color='gray-o' size="sm" onClick={() => setmodal6714IsOpen(false)}>취소</Button>
						<Button color='pri' size="sm" onClick={onClickSave}>저장</Button>
					</div>
				</div>	
			</ModalPopup>		

			{/* modal - 6715 */}
			<ModalPopup
				open={modal6715IsOpen}
				title="모계좌관리 수정"
				size="sm"
				onClose={() => onClose6715()}
			>
				<div className="modal-con">
				<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">펌뱅킹기관코드</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={FIRM_CD} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">은행</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={BANK_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">계좌번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ACCT_NO} type='number' placeholder={'- 숫자만 입력'}  valueChanged={(value) => SetACCT_NO(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">계좌별칭</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ACCT_NM} placeholder={''} valueChanged={(value) => SetACCT_NM(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">대표계좌</p>
								<div className="fo-value">
									<div className="hz-root hz-gap15 h36">
										<label htmlFor="rd-1-1" className="ip-rd-label">
											<input name="rd-1" id="rd-1-1" className="ip-rd" type="radio" value='Y' checked={DEF_ACCT_YN === 'Y'} onChange={handleOptionChange}/>
											<span className="check"></span>
											<span className="txt">예</span>
										</label>
										<label htmlFor="rd-1-2" className="ip-rd-label">
											<input name="rd-1" id="rd-1-2" className="ip-rd" type="radio" value='N' checked={DEF_ACCT_YN === 'N'} onChange={handleOptionChange}/>
											<span className="check"></span>
											<span className="txt">아니오</span>
										</label>
									</div>									
								</div>
							</div>

						</div>
					</form>
				</div>
				<div className="modal-bottom">
				<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => setmodal6715IsOpen(false)}>취소</Button>
						<Button color='pri' size="md" onClick={onClickUpdate}>저장</Button>
					</div>
				</div>	
			</ModalPopup>					
		</PageContainer>
	);
}
export default ContentsContainer;